import React from "react";

const OverlayMessage = ({ message }) => {
	return message ? <div className="overlay-message">{message}</div> : null;
};

export default OverlayMessage;